// extracted by mini-css-extract-plugin
export default {"mCard":"fD-z","image":"gD-z","imageNoBackground":"hD-z","imageHasCategory":"iD-z","fullWidth":"jD-z"};